/**
 * Search Filter Toggle
 * @author Rhys Lloyd
 */

// Utilities
import debug from "debug";
const MODULE_NAME = 'search-filter-toggle';
const log = debug(MODULE_NAME);

//
// Dependencies
import keys from 'lodash/keys';

//
// Constants
const SEARCH_FORM_SELECTOR = '.search-form';
const SEARCH_FILTER_SELECTOR = '.search-filter-toggle';
const TOGGLE_INDICATOR_SELECTOR = '.search-filter-toggle__indicator';
const INPUT_TYPES = [
	'input[type]',
	'select',
];
const INPUT_EXCLUSION = [
	'input[type="hidden"]'
];
const IS_HIDDEN = 'is-hidden';

//
// Functions
function getSelectedFilterMap (inputs) {
	const $inputs = $(inputs);
	const selectedFilters = {};

	$inputs.each((index, /** @type {HTMLInputElement} */ input) => {
		let value;

		switch (input.type) {
			case 'checkbox':
			case 'radio':
				if (input.checked) {
					value = true;
				}
				break;
			default:
				if (input.value && input.value.length) {
					value = input.value;
				}
		}

		if (value) {
			selectedFilters[input.name] = value;
		}
	});

	return selectedFilters;
}

function getFilterInputs (context) {
	return $(context).find(INPUT_TYPES.join(',')).not(INPUT_EXCLUSION.join(','));
}

function getToggleIndicator (context) {
	return $(context).parents(SEARCH_FORM_SELECTOR).find(TOGGLE_INDICATOR_SELECTOR);
}

function toggleIndicatorState (toggleIndicator, showToggle) {
	const $toggleIndicator = $(toggleIndicator);

	if (showToggle) {
		$toggleIndicator.removeClass(IS_HIDDEN);
	} else {
		$toggleIndicator.addClass(IS_HIDDEN);
	}

	log(showToggle ? 'Show' : 'Hide', 'toggle indicator.');
	return showToggle;
}

function updateToggleIndicator(inputs, toggleIndicator) {
	const $inputs = $(inputs);
	const $toggleIndicator = $(toggleIndicator);

	const selectedFilterMap = getSelectedFilterMap($inputs);
	const selectedFilters = /** @type {Array} */ keys(selectedFilterMap);
	const showToggle = selectedFilters && selectedFilters.length;
	return toggleIndicatorState($toggleIndicator, showToggle);
}

function initialiseSearchFilter (searchFilter) {
	const $inputs = getFilterInputs(searchFilter);
	const $toggleIndicator = getToggleIndicator(searchFilter);

	updateToggleIndicator($inputs, $toggleIndicator);

	$inputs.on('change', () => {
		updateToggleIndicator($inputs, $toggleIndicator);
	});
}

//
// Export
export function exec () {
	const $searchFilters = $(SEARCH_FILTER_SELECTOR);

	if (!$searchFilters.length) {
		return;
	}

	$searchFilters.each((index, searchFilter) => {
		initialiseSearchFilter(searchFilter);
	});
}

export {exec as default};


// WEBPACK FOOTER //
// ./project/client/src/core/modules/navigation/search-filter-toggle.js